<template>
    <component :is="template">
        <v-sheet color="white">
            <section class="clover-section clover-section--1">
                <div class="clover-spacer clover-spacer--1" />
                
                <v-img eager src="/images/event/clover/mobile/mobile-title.svg" alt="클로버 위크 카드 속 숨어있는 행운을 찾아보세요! 2024.08.12 - 2024.08.25" class="event-title d-md-none" />
                <v-img eager src="/images/event/clover/title.svg" alt="클로버 위크 카드 속 숨어있는 행운을 찾아보세요! 2024.08.12 - 2024.08.25" class="event-title d-none d-md-block" />

                <div class="clover-spacer clover-spacer--2" />

                <v-img eager src="/images/event/clover/mobile/event-section-title-1.svg" class="event-section-title event-section-title--1 d-md-none" alt="행운 상품" />
                <v-img eager src="/images/event/clover/event-section-title-1.svg" class="event-section-title event-section-title--1 d-none d-md-block" alt="행운 상품" />

                <div class="clover-spacer clover-spacer--3" />

                <prize-list />
            </section>

            <section>
                <!-- 당첨자 슬라이드 -->
                <score-board v-if="loading" :logs="logs"/>
            </section>

            <section class="clover-section clover-section--2">
                <div class="clover-spacer clover-spacer--4" />

                <v-img eager src="/images/event/clover/mobile/event-section-title-2.svg" class="event-section-title event-section-title--2 d-md-none" alt="행운 카드 고르기" />
                <v-img eager src="/images/event/clover/event-section-title-2.svg" class="event-section-title event-section-title--2 d-none d-md-block" alt="행운 카드 고르기" />

                <div class="clover-spacer clover-spacer--5" />

                <!-- 행운 카드 -->
                <lucky-cards @init="init"/>

                <div class="clover-spacer clover-spacer--6" />

                <v-img eager src="/images/event/clover/mobile/event-section-title-3.svg" class="event-section-title event-section-title--3 d-md-none" alt="나누리 상품권&amp;캐시 어디에 쓰지?" />
                <v-img eager src="/images/event/clover/event-section-title-3.svg" class="event-section-title event-section-title--3 d-none d-md-block" alt="나누리 상품권&amp;캐시 어디에 쓰지?" />

                <div class="clover-spacer clover-spacer--7" />

                <link-cards />

                <div class="clover-spacer clover-spacer--8" />

                <v-img eager src="/images/event/clover/mobile/event-section-title-4.svg" class="event-section-title event-section-title--4 d-md-none" alt="꼭 확인해주세요!" />
                <v-img eager src="/images/event/clover/event-section-title-4.svg" class="event-section-title event-section-title--4 d-none d-md-block" alt="꼭 확인해주세요!" />

                <div class="clover-spacer clover-spacer--9" />

                <v-img src="/images/event/clover/mobile/precautions.svg" class="precautions d-md-none" />
                <v-img src="/images/event/clover/precautions.svg" class="precautions d-none d-md-block" />
            </section>
        </v-sheet>
    </component>
</template>

<script>
import api from "@/api";
import PrizeList from "@/components/client/event/clover/prize-list.vue";
import ScoreBoard from "@/components/client/event/clover/score-board.vue";
import LuckyCards from "@/components/client/event/clover/lucky-cards.vue";
import LinkCards from "@/components/client/event/clover/link-cards.vue";

export default {
    components: {
        PrizeList,
        ScoreBoard,
        LuckyCards,
        LinkCards,
    },
    data() {
        return {
            logs: [],
            loading: false
        }
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            this.loading = false
            let { logs } = await api.v1.clover.logs.gets({})
            this.logs = logs
            this.loading = true
        }
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.main}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.clover-section {
    background-color: #caffb1;
    background-position: center;
    background-size: cover;
    max-width: 1920px;
    margin: 0 auto;

    &--1 {
        background-image: url(/images/event/clover/mobile/section-bg-1.jpg);
        aspect-ratio: 768 / 3490;
    }
    &--2 {
        background-image: url(/images/event/clover/mobile/section-bg-2.jpg);
        aspect-ratio: 768 / 5460;
    }
}
.event-title {
    margin: 0 auto; 
    max-width: calc(270 / 360 * 100%);
}
.event-text {
    margin: 0 auto;
    max-width: calc(248 / 360 * 100%);
}
.event-section-title {
    margin: 0 auto;

    &--1 {
        max-width: calc(190 / 360 * 100%);
    }
    &--2 {
        max-width: calc(286 / 360 * 100%);
    }
    &--3 {
        max-width: calc(255 / 360 * 100%);
    }
    &--4 {
        max-width: calc(276 / 360 * 100%);
    }
}
.clover-spacer {
    &--1 {
        aspect-ratio: 360 / 112;
    }
    &--2 {
        aspect-ratio: 360 / 558;
    }
    &--3 {
        aspect-ratio: 360 / 64;
    }
    &--4 {
        aspect-ratio: 360 / 82;
    }
    &--5 {
        aspect-ratio: 360 / 60;
    }
    &--6 {
        aspect-ratio: 360 / 204;
    }
    &--7 {
        aspect-ratio: 360 / 27.5;
    }
    &--8  {
        aspect-ratio: 360 / 140;
    }
    &--9  {
        aspect-ratio: 360 / 104;
    }
}
.precautions {
    margin: 0 auto;
        max-width: calc(260 / 360 * 100%);
    }
@media (min-width: 768px) {
    .event-title {
        max-width: calc(620 / 1920 * 100%);
    }
    .event-section-title {
        &--1 {
            max-width: calc(240 / 1920 * 100%);
        }
        &--2 {
            max-width: calc(396 / 1920 * 100%);
        }
        &--3 {
            max-width: calc(682 / 1920 * 100%);
        }
        &--4 {
            max-width: calc(468 / 1920 * 100%);
        }
    }
    .clover-section {
        &--1 {
            background-image: url(/images/event/clover/section-bg-1.jpg);
            aspect-ratio: 1920 / 2158;
        }
        &--2 {
            background-image: url(/images/event/clover/section-bg-2.jpg);
            aspect-ratio: 1920 / 3156;
        }
    }
    .clover-spacer {
        &--1 {
            aspect-ratio: 1920 / 150;
        }
        &--2 {
            aspect-ratio: 1920 / 646;
        }
        &--3 {
            aspect-ratio: 1920 / 40;
        }
        &--4 {
            aspect-ratio: 1920 / 120;
        }
        &--5 {
            aspect-ratio: 1920 / 90;
        }
        &--6 {
            aspect-ratio: 1920 / 230;
        }
        &--7 {
            aspect-ratio: 1920 / 56;
        }
        &--8 {
            aspect-ratio: 1920 / 228;
        }
        &--9 {
            aspect-ratio: 1920 / 66;
        }
    }
    .precautions {
        max-width: calc(1340 / 1920 * 100%);
    }
}
</style>
